<template>
  <div class="messaging-ct">
    <div style="width: 450px">
      <p>
        {{ $t('Gamification_Thunderbite_Messaging_Xtremepush_Now_Features') }}
      </p>
    </div>
    <div>
      <img
        src="@/img/gamification/xp-tb.png"
        :alt="$t('Gamification_Thunderbite_Messaging_Xtremepush_Now_Features')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GamificationThunderbiteMessaging'
}
</script>

<style scoped>
.messaging-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 65px;
  gap: 40px;
}

p {
  color: #5c6374;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationThunderbiteMessaging.vue